import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the very top on every route change (handles Lenis too),
// so links/buttons always land at the top of the new page.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
    // Fallback after layout settles (covers the very first navigation).
    const id = requestAnimationFrame(() => {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(id);
  }, [pathname]);

  return null;
}
